var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1SadHilite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "hilite",
    fill: "#4A90E2",
    cx: 34,
    cy: 34,
    r: 33
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 34,
    cy: 34,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,55.0189474 C22.3789474,55.0189474 12.9810526,45.6210526 12.9810526,34 C12.9810526,22.3789474 22.3789474,12.9810526 34,12.9810526 C45.6210526,12.9810526 55.0189474,22.3789474 55.0189474,34 C55.0189474,45.6210526 45.6210526,55.0189474 34,55.0189474 M34,10 C20.7621053,10 10,20.7621053 10,34 C10,47.2378947 20.7621053,58 34,58 C47.2378947,58 58,47.2378947 58,34 C58,20.7621053 47.2378947,10 34,10 M34.1390677,38 C39.7494753,38 44.9195814,40.6601786 48.1998262,45.0798094 C48.6935549,45.7450338 48.5545302,46.6845509 47.8893059,47.1782796 C47.2240815,47.6720084 46.2845644,47.5329837 45.7908357,46.8677593 C43.0706241,43.2026881 38.7896593,41 34.1390677,41 C29.6326931,41 25.4701086,43.0671218 22.7359654,46.5423812 C22.2237305,47.1934625 21.2806763,47.3060196 20.629595,46.7937846 C19.9785138,46.2815497 19.8659566,45.3384955 20.3781916,44.6874142 C23.6752155,40.4966998 28.7028457,38 34.1390677,38 Z M22.88,30 C24.4705684,30 25.76,31.2894316 25.76,32.88 C25.76,34.4710737 24.4705684,35.76 22.88,35.76 C21.2894316,35.76 20,34.4710737 20,32.88 C20,31.2894316 21.2894316,30 22.88,30 Z M45.88,30 C47.4705684,30 48.76,31.2894316 48.76,32.88 C48.76,34.4710737 47.4705684,35.76 45.88,35.76 C44.2894316,35.76 43,34.4710737 43,32.88 C43,31.2894316 44.2894316,30 45.88,30 Z",
    id: "Fill-1",
    fill: "#F5A623"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1SadHilite);
export default __webpack_public_path__ + "static/media/1 Sad_hilite.4bd0a2cb3a529bc856a6e00e540b64c5.svg";
export { ForwardRef as ReactComponent };